import React, { useContext } from "react";

/**
 * Whether the donate flow is running in the locked-down embedded (iframed)
 * mode: guest donors only, no post-donation signup. Provided by
 * DonateV3Wrapper from the embedMode prop; see docs/embed-donate.md.
 *
 * Prefer formContext.embedMode where a DonateFormContext is already at
 * hand; this context exists for components that don't receive one.
 */
export const EmbedModeContext = React.createContext(false);

export function useEmbedMode(): boolean {
  return useContext(EmbedModeContext);
}
